export const MEALS_RATE = 59;
export const EMOJIS = {
  smile: {
    upsideDown: '\u{1F643}',
  },
};

export const MONTH_LIST = [
  {
    id: 1,
    description: 'January',
  },
  {
    id: 2,
    description: 'February',
  },
  {
    id: 3,
    description: 'March',
  },
  {
    id: 4,
    description: 'April',
  },
  {
    id: 5,
    description: 'May',
  },
  {
    id: 6,
    description: 'June',
  },
  {
    id: 7,
    description: 'July',
  },
  {
    id: 8,
    description: 'August',
  },
  {
    id: 9,
    description: 'September',
  },
  {
    id: 10,
    description: 'October',
  },
  {
    id: 11,
    description: 'November',
  },
  {
    id: 12,
    description: 'December',
  },
];

export const NON_NUM_REGEXP = /[^0-9.]/g;

export const AUTH_KEY = 'hgczxlcnoasdOOOpplszmzm';

export const NULL_TIME = '0001-01-01 00:00:00';

export const EMPTY_VALUES = [0, '', NULL_TIME];
export const IGNORE_FIELDS = [
  'orderBy',
  'orderDir',
  'groupBy',
  'pageNumber',
  'notEquals',
];
